import { useLinkWithRelatedQuery } from '@/hooks/useGraphQLQueries';
import type { RelatedLink } from '@/api/client';

/**
 * Hook to fetch related links based on shared user tags.
 * Returns links in the same queue that share user tags like instagram:user:*, reddit:u:*, etc.
 *
 * Migrated from TanStack Query + REST to urql + GraphQL.
 */
export function useRelatedLinks(linkId: number | null, queueId: number, pause = false) {
	const {
		relatedLinks,
		sourceUserTags,
		totalRelated,
		loading,
		error,
	} = useLinkWithRelatedQuery(
		// Only enable for valid queues (include Inbox=0, exclude Archive=-1)
		linkId !== null && queueId >= 0 && !pause ? linkId : null,
		queueId
	);

	// Return shape compatible with previous REST-based hook
	return {
		data: linkId !== null && queueId >= 0
			? {
					total: totalRelated,
					relatedLinks: relatedLinks as RelatedLink[],
					sourceLink: {
						userTags: sourceUserTags,
					},
				}
			: undefined,
		isLoading: loading,
		error,
	};
}
